/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Born on a`)
};

const es_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacido en un`)
};

const de_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geboren an einem`)
};

const nl_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geboren op een`)
};

const fr_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Né un`)
};

const it_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nato/a di`)
};

const pt_br2_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasceu em um`)
};

const pt_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasceu numa`)
};

const ja_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生まれた曜日`)
};

const zh_age_weekday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出生星期`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_weekday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_weekday(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_weekday", locale)
	if (locale === "en") return en_age_weekday(inputs)
	if (locale === "es") return es_age_weekday(inputs)
	if (locale === "de") return de_age_weekday(inputs)
	if (locale === "nl") return nl_age_weekday(inputs)
	if (locale === "fr") return fr_age_weekday(inputs)
	if (locale === "it") return it_age_weekday(inputs)
	if (locale === "pt-BR") return pt_br2_age_weekday(inputs)
	if (locale === "pt") return pt_age_weekday(inputs)
	if (locale === "ja") return ja_age_weekday(inputs)
	return zh_age_weekday(inputs)
};